<template>
    <button>
        <svg width="30px" height="30px" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" mirror-in-rtl="true" fill="#000000">

            <g id="SVGRepo_bgCarrier" stroke-width="0"/>
            
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
            
            <g id="SVGRepo_iconCarrier"> <path fill="#016B00" d="M17.99 11.5a1 1 0 0 1-1 1h-2v2a1 1 0 0 1-2 0v-2h-2a1 1 0 0 1 0-2h2v-2a1 1 0 0 1 2 0v2h2a1 1 0 0 1 1 1z"/> <path fill="#016B00" d="M14 5.5a5.968 5.968 0 0 1 4 1.537V3.5a2.006 2.006 0 0 0-2-2H2a1.5 1.5 0 0 0-.37.04A1.98 1.98 0 0 0 .04 3.13 1.5 1.5 0 0 0 0 3.5v8a1.5 1.5 0 0 0 .04.37 1.98 1.98 0 0 0 1.59 1.59 1.5 1.5 0 0 0 .37.04v2a.987.987 0 0 0 .62.92.84.84 0 0 0 .38.08 1.007 1.007 0 0 0 .71-.29L6 13.5h2.35a5.986 5.986 0 0 1 5.65-8z"/> </g>
            
            </svg>
    </button>
</template>